import {TypeImplementation} from '@packages/systems/wfdl';
import {iconName, pluginName, qualify} from '@packages/systems/wfdl-Qualified';

/**
 * The deprecated Devlink::RuntimeProps type. Authoring is gone and existing
 * bindings are migrated to Basic::Attributes, so the type renders nothing in
 * the editor. It stays registered (rather than deleted) so the qualified name
 * keeps resolving: `createDevlinkAtom` still declares the field, and the name
 * survives in persisted element data (`data.devlink.runtimeProps` defaults),
 * compiled library payloads, and printed component text — none of which
 * migration 110 rewrites. Deleting the type entirely is phase 4 of the
 * DevLink datatypes retirement plan, gated on the migrations draining:
 * https://webflow.atlassian.net/wiki/spaces/DPL/pages/2989457673/Retiring+DevLink+s+bespoke+DataTypes+and+horizontal+settings
 */
export const RuntimePropsType = TypeImplementation.Custom({
  render: () => null,
  system: {
    isFullWidth: true,
    bindUIVariant: 'custom',
  },
  icon: TypeImplementation.IconByName(
    qualify(pluginName('Devlink'), iconName('RuntimeProps'))
  ),
});
